import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import { useFormik, FormikHelpers } from "formik";
import axios from "axios";
import toaster from "../../../../Utils/toaster";

const API_URL = process.env.REACT_APP_API_URL;
interface FormValues {
    secondaryNumber: string;
}

interface SecondaryNumberViewProps {
  userID: string
}


export const SecondaryNumberView: React.FC<SecondaryNumberViewProps> = ({ userID }) => {
    const [addSecondaryNumber, setAddSecondaryNumber] = useState<boolean>(true);
    const [numbers,setNumbers] = useState<string[]>([]);
    const [fieldsError,setFieldsError] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    
const getExistingPhoneNumbers = async (userId: string | undefined) => {
    setIsLoading(true);
    if (!userId) return;
    try {
        const response = await axios.get(`${API_URL}/UserAdditionalPhone/GetByUserId/${userId}`)
        setNumbers(response?.data?.additionalPhones || []);
        setIsLoading(false)
    } catch (error) {
        console.error(error)
        toaster("error",'Unable to Fetch Additional Numbers');
        setIsLoading(false) 
    }
}

const deleteUserPhoneNumber = async (id: string) => {
    setIsLoading(true);
    try {
        await axios.delete(`${API_URL}/UserAdditionalPhone/Delete/${id}`);
        setIsLoading(false)
        toaster("success", "Number deleted successfully");
        setNumbers((prev) => prev.filter((num: any) => num.id !== id));
    } catch (error) {
        console.error(error);
        toaster("error", "Unable to delete number");
    } finally {
        setIsLoading(false);
    }
}


      const addUserPhoneNumber  = async (userId: string, phoneNumber: string) => {
        setIsLoading(true);
        if (!userId) return; // Also fixed: you used 'id' instead of 'customerId'
        try {
          await axios.post(`${API_URL}/UserAdditionalPhone/Add`, {
            userId: userId, // Also fixed: you used 'id' instead of 'customerId'
            phoneNumber: phoneNumber,
          });
        toaster("success",'Additional number added successfully');
        getExistingPhoneNumbers(userId);
        setIsLoading(false);
    
        } catch (error) {
          console.error(error);
            const errorMessage =
              (error as any)?.response?.data?.text ||
              (error as any)?.response?.data?.Text ||
              'unable to add additional number';
            toaster("error", errorMessage);
            setIsLoading(false);
    
        }
      }

        useEffect(() => {
          getExistingPhoneNumbers(userID)
        }, [])

const formik = useFormik<FormValues>({

    initialValues: {
        secondaryNumber: "",
    },
    validate: (values) => {
        setFieldsError("");
        const errors: Partial<FormValues> = {};
        const num = values.secondaryNumber.replace(/\D/g, ""); // Remove non-digits
        if (!num || num.length === 0) {
            setFieldsError("Number is required");
            errors.secondaryNumber = "Number is required";
        } else if (num.length < 7 || num.length > 15) {
            setFieldsError("Number is not correct");
            errors.secondaryNumber = "Number is not correct";
        } 
        console.log(errors)
        return errors;
    },
    onSubmit: (values: FormValues, helpers: FormikHelpers<FormValues>) => {

        addUserPhoneNumber(userID,values.secondaryNumber);
    },
});


    return (
        <div>
             <div className="">
                <h3>List of Additional Numbers</h3>
               {numbers.length > 0 ?  <ul className="list-group my-4">
                    {numbers.map((num:any, idx) => (
                        <li key={idx} className="list-group-item d-flex justify-content-between align-items-center ">
                            <span>{num?.phoneNumber}</span>
                            <Button
                                variant="danger"
                                size="sm"
                                onClick={() => deleteUserPhoneNumber((num?.id))}
                            >
                            
                            Delete    
                            </Button>
                        </li>
                    ))}
                </ul>: <p className="">No secondary numbers added yet.</p>}
            </div>
            {addSecondaryNumber && <Button variant="primary" onClick={() => setAddSecondaryNumber(!addSecondaryNumber)} className="w-100">Add New Number</Button>}
           
            {!addSecondaryNumber && <form onSubmit={formik.handleSubmit}>
                <div className='mb-3'>
                    <label htmlFor='secondaryNumber' className='form-label fs-7 mb-1'>
                        Secondary Contact Number
                    </label>
                    <PhoneInput
                        id='secondaryNumber'
                        name='secondaryNumber'
                        international
                        defaultCountry='US'
                        value={formik.values.secondaryNumber}
                        onChange={(value: string | undefined) =>
                            formik.setFieldValue('secondaryNumber', value || '')
                        }
                        className='phoneNumber form-control form-control-white form-select-sm mb-2 custom-input-height'
                    />
                    {fieldsError && <div className="text-danger fs-7">{fieldsError}</div>}
                   
                </div>
                
                <div className="w-100 d-flex justify-content-end">
                    <Button type="submit" variant="secondary" className="" onClick={() => setAddSecondaryNumber(true)}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" className=" ms-3">
                        Save Numbers
                    </Button>
                </div>
            </form>}
        </div>
    );
};
